import { JSONForm } from '@conventioncatcorp/common-fe/dist/components/json-form/JSONForm';
import React, { FC, useCallback, useState } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button, Card, CardBody, CardTitle, Col, FormGroup, Input, Label, Row } from 'reactstrap';
import { passwordScore } from '../../../shared/user/password';
import {
  MaterialIcon,
  PageHeader,
  PasswordChangeInput,
  UserStateComponent,
} from '../../components';
import { useQuery } from '../../utils';

const Form: FC<{ readonly onSuccess: () => void }> = ({ onSuccess }) => {
  const qry = useQuery();
  const code = qry.get('code') ?? '';

  return (
    <>
      <p>
        To complete your password reset, please provide the code you were provided either by email
        or by the at-con registration staff.
      </p>
      <hr />
      <div className="text-center">
        <JSONForm id="resetForm" method="patch" onSuccess={onSuccess} path="/api/users/reset">
          <FormGroup row>
            <Label for="id" sm={4}>
              Reset Code
            </Label>
            <Col sm={8}>
              <Input defaultValue={code} id="code" name="code" required />
            </Col>
          </FormGroup>
          <hr />
          <PasswordChangeInput isNew passwordScore={passwordScore} sm={8} />
          <FormGroup>
            <Button block color="primary" id="resetPassword" type="submit">
              Reset Password
            </Button>
          </FormGroup>
          <FormGroup>
            <Link className="btn btn-outline-secondary btn-block" id="loginPage" to="/login">
              Back to Login
            </Link>
          </FormGroup>
        </JSONForm>
      </div>
    </>
  );
};

const Success: FC = () => {
  const redirect = useQuery().get('redirect');

  if (redirect) {
    toast.success('Your password has been reset and you can now login.');
    return <Redirect to={redirect} />;
  }

  return (
    <div className="text-center" id="resetComplete">
      <MaterialIcon className="margin-bottom-10" large name="security" type="success" />
      <CardTitle>Success!</CardTitle>
      <p>Your password has been successfully reset and you can now login.</p>
      <hr />
      <Link className="btn btn-link btn-block" to="/login">
        Go back to Login
      </Link>
    </div>
  );
};

export const ResetComponent: FC = () => {
  const [success, setSuccess] = useState(false);
  const onSuccess = useCallback(() => {
    setSuccess(true);
  }, []);

  return (
    <UserStateComponent requireLoggedOut>
      <PageHeader>Password Reset</PageHeader>
      <Row className="justify-content-center">
        <Col lg={6} xs={12}>
          <Card>
            <CardBody>{success ? <Success /> : <Form onSuccess={onSuccess} />}</CardBody>
          </Card>
        </Col>
      </Row>
    </UserStateComponent>
  );
};
